import { Injectable } from "@angular/core";
import { IIDFaultManagementStore } from "./iidFaultManagement.store";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IID_FAULT_MANAGEMENT } from "@common/interfaces/interfaceData";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.FAULT_MANAGEMENT)
export class IIDFaultManagementQuery extends AbstractInterfaceDataQuery<IID_FAULT_MANAGEMENT> {

  constructor(protected store: IIDFaultManagementStore) {
    super(store);
  }

}
